var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPrefixArrowUpBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "ho3xafiowa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.235294 0 0 0 0 0.364706 0 0 0 0 0.949020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.79.539A.9.9 0 0 1 5.92.466l.09.073 3.9 3.6a.9.9 0 0 1-1.133 1.394L8.69 5.46 5.4 2.424 2.11 5.461a.9.9 0 0 1-1.19.028L.84 5.41A.9.9 0 0 1 .81 4.22L.89 4.14l3.9-3.6z",
    id: "15djigqycb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ho3xafiowa)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.6 6.3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ncez0whj3c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#15djigqycb"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#15djigqycb"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ncez0whj3c)",
    fill: "#9EA0A5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3.6-6.3h18v18h-18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrefixArrowUpBlue);
export default __webpack_public_path__ + "static/media/ico-prefix-arrow-up-blue.bcf2b81f790644c18a6ac33675605a4b.svg";
export { ForwardRef as ReactComponent };